export default [
    {
        path: "/ess/documents",
        name: "EssOrganisationCompanyDocuments",
        component: () => import("@/modules/Ess/Documents/index"),
        meta: {
            authRequired: true,
            employeeUrl: true
        }
    },
    {
        path: "/ess/documents/employee",
        name: "EssEmployeeDocs",
        component: () => import("@/modules/Ess/Documents/employeeDocs/index"),
        meta: {
            authRequired: true,
            employeeUrl: true
        }
    },
    {
        path: "/documents/folder/view-folder",
        name: "EssViewFolder",
        component: () => import("@/modules/Ess/Documents/viewFolder"),
        meta: {
            authRequired: true,
            employeeUrl: true
        }
    },
    {
        path: "ess/documents/employee/recycleBin",
        name: "EssEmployeesRecycleBin",
        component: () => import("@/modules/Ess/Documents/employeeDocs/documents/recycleBin"),
        meta: {
            authRequired: true,
            employeeUrl: true
        }
    },
]